import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { makeSelectSprayWorksheetEquipmentSetTankVolume } from 'scenes/Spray/scenes/Diary/components/PrintSprayWorksheetModal/components/PrintSprayWorksheetEquipmentSet/selectors';
import { WorksheetEntitySummaryIndex } from 'services/worksheet/types';
import { selectSprayWorksheetProducts } from 'scenes/Spray/scenes/Diary/components/PrintSprayWorksheetModal/components/PrintSprayWorksheetProducts/components/PrintSprayWorksheetProductsTable/selectors';
import { selectSprayWorksheetEntitySummaries } from '../../../../selectors';
import { OwnProps } from './index';

const selectEntitySummaryIndex = (
    state: AppState,
    props: OwnProps
): WorksheetEntitySummaryIndex => props.entitySummaryIndex;

const selectTanksEstimated = createDeepEqualSelector(
    selectSprayWorksheetEntitySummaries,
    selectEntitySummaryIndex,
    makeSelectSprayWorksheetEquipmentSetTankVolume(),
    selectSprayWorksheetProducts,
    (entitySummaries, index, tankVolume, products) => {
        const sumTotalArea = get(entitySummaries, [index, 'sumTotalArea']);
        const sprayedRatio = get(entitySummaries, [index, 'sprayedRatio']);
        const waterRate = get(products, [0, 'waterRate'], 0);

        return Number(
            ((sumTotalArea * sprayedRatio * waterRate) / tankVolume).toFixed(2)
        );
    }
);

const makeSelectTanksEstimated = (): typeof selectTanksEstimated =>
    selectTanksEstimated;

export { selectEntitySummaryIndex, makeSelectTanksEstimated };
